import TimerWorker from './worker?sharedworker&inline'
import type { TimerFunction, TimerEvent, WorkerEvent } from './types'

class Timer {
  readonly delay: number
  #subscribers: Map<number, TimerFunction>

  constructor(delay: number) {
    this.delay = delay
    this.#subscribers = new Map()
  }

  get size() {
    return this.#subscribers.size
  }

  call() {
    for (const cb of this.#subscribers.values()) {
      window.setTimeout(cb)
    }
  }

  subscribe(id: number, func: TimerFunction) {
    this.#subscribers.set(id, func)
  }

  unsubscribe(id: number) {
    this.#subscribers.delete(id)
  }
}

const timerByDelay = new Map<number, Timer>()
const worker = new TimerWorker()

let callbackId = 0
const newCallbackId = () => ++callbackId
const timerByCallback = new Map<number, Timer>()

worker.port.onmessage = ({ data }: MessageEvent<TimerEvent>) => {
  switch (data.type) {
    case 'tick': {
      timerByDelay.get(data.delay)?.call()
      break
    }
  }
}

window.addEventListener('beforeunload', () => {
  const msg: WorkerEvent = { type: 'close' }
  worker.port.postMessage(msg)
})

export function runTimer(func: TimerFunction, delay: number) {
  let timer = timerByDelay.get(delay)
  if (!timer) {
    timer = new Timer(delay)
    timerByDelay.set(delay, timer)
    const msg: WorkerEvent = { type: 'subscribe', delay }
    worker.port.postMessage(msg)
  }
  const id = newCallbackId()
  timer.subscribe(id, func)
  timerByCallback.set(id, timer)
  return id
}

export function clearTimer(id: number) {
  const timer = timerByCallback.get(id)
  if (timer) {
    timerByCallback.delete(id)
    timer.unsubscribe(id)
    if (timer.size === 0) {
      timerByDelay.delete(timer.delay)
      const msg: WorkerEvent = { type: 'unsubscribe', delay: timer.delay }
      worker.port.postMessage(msg)
    }
  }
}
